import React, { useState } from 'react';
import { ChangeViewButtonProps } from './change-view-button.types';
import { Tooltip } from '@mui/material';
import { Flex } from '../../../common/common-components.styled';
import IconHover from '../../icon-hover';
import { SwitchViewIcon } from '../../icons-new/switch-view';
import { ListViewIcon } from '../../icons-new/list-view';

const ChangeViewButton = ({ listView, changeListView }: ChangeViewButtonProps) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <Flex left='20'>
      <Tooltip
        placement='top'
        title={listView ? 'Kachelnansicht' : 'Listenansicht'}
        open={tooltipOpen}
        onMouseEnter={() => setTooltipOpen(true)}
        onMouseLeave={() => setTooltipOpen(false)}
        onClick={() => {
          setTooltipOpen(false);
          changeListView();
        }}
      >
        <Flex>
          <IconHover>
            {listView ? <SwitchViewIcon width='22' height='21' /> : <ListViewIcon width='13' height='14' />}
          </IconHover>
        </Flex>
      </Tooltip>
    </Flex>
  );
};

export default ChangeViewButton;
